/*
 * Copyright (c) 2019. IOWEB TECHNOLOGIES
 */

import $ from 'jquery';

$(window).on('load', function () {

    let $checkout = $('#checkout');
    if ($checkout.length > 0) {

        $('[name="ioShippingRadio"]').attr('required', 'required');

        let optionSplit = '#radio_ioShippingRadio_0';
        let optionTogetherDefault = '#radio_ioShippingRadio_1';
        let optionExisting = '#radio_ioShippingRadio_2';
        let optionNotify = '#radio_ioShippingRadio_3';

        var eventList = $._data($("#wk-payment-confirmation button")[0]);
        console.dir(eventList);

// let labelTogether = 'label[for="radio_56"]';
// let labelSplit = 'label[for="radio_55"]';
// let labelExisting = 'label[for="radio_57"]';

        window.io_shipping_choice = false;
        $(optionSplit).click(function () {
            window.io_shipping_choice = optionSplit;
            window.ioUserChecked = true;
        });

        $(optionTogetherDefault).click(function () {
            window.io_shipping_choice = optionTogetherDefault;
            window.ioUserChecked = true;
        });

        $(optionExisting).click(function () {
            window.io_shipping_choice = optionExisting;
            window.ioUserChecked = true;
        });
        $(optionNotify).click(function () {
            window.io_shipping_choice = optionNotify;
            window.ioUserChecked = true;
        });

        if (typeof window.ioUserChecked === 'undefined') {
            window.ioUserChecked = false;
        }
        if (typeof window.ioRadioHidden === 'undefined') {
            window.ioRadioHidden = false;
        }

        displayShippingOptionsByBackorder();


        function backOrderExists() {
            let backorderRows = $('[data-backorder="1"]');
            let length = backorderRows.length;

            if (length > 0)
                return true;
            else
                return false;
        }


        function displayShippingOptionsByBackorder() {
            let $customFieldsBlock = $(optionNotify).parent('p');
            // console.log('userchecked', window.ioUserChecked);
            // console.log('hidden', window.ioRadioHidden);

            if (backOrderExists()) {
                // if (window.ioRadioHidden === false) {
                //     // $customFieldsBlock.hide();
                //     // window.ioRadioHidden = true;
                // }
                if (window.ioUserChecked === false) {
                    console.log('unchecking  backorder custom fields');
                    uncheckRadios();
                }
                else{
                    selectUserChoice();
                }
                blockDefaultRadio();
            } else {
                // if($customFieldsBlock.is(":hidden")){
                //     console.log('showing option 4');
                //     // $customFieldsBlock.show();
                // }
                let $defaultOptionRadio = $(optionNotify);
                if (!$defaultOptionRadio.prop('checked')) {
                    console.log('checking default option');
                    checkById(optionNotify);
                }
                blockNonDefaultRadios();

            }
        }

        function selectUserChoice(){
            let $radio = $(window.io_shipping_choice);
            $radio.prop('checked', true).trigger('change');
            $radio.attr('checked', true).trigger('change');
            $radio.trigger('focusout');
        }

        function uncheckRadios() {
            let $radio1 = $(optionTogetherDefault);
            let $radio2 = $(optionSplit);
            let $radio3 = $(optionExisting);
            let $radio4 = $(optionNotify);

            $radio1.prop('checked', false).trigger('change');
            $radio1.attr('checked', false).trigger('change');
            $radio1.trigger('focusout');

            $radio2.prop('checked', false).trigger('change');
            $radio2.attr('checked', false).trigger('change');
            $radio2.trigger('focusout');

            $radio3.prop('checked', false).trigger('change');
            $radio3.attr('checked', false).trigger('change');
            $radio3.trigger('focusout');

            $radio4.prop('checked', false).trigger('change');
            $radio4.attr('checked', false).trigger('change');
            $radio4.trigger('focusout');

            $radio1.parents('div').find('.checkboxes').val('');
            $radio2.parents('div').find('.checkboxes').val('');
            $radio3.parents('div').find('.checkboxes').val('');
            $radio4.parents('div').find('.checkboxes').val('');

            $radio1.prop('disabled', false).trigger('change');
            $radio2.prop('disabled', false).trigger('change');
            $radio3.prop('disabled', false).trigger('change');
            $radio4.prop('disabled', false).trigger('change');
        }

        function blockNonDefaultRadios() {
            let $radio1 = $(optionTogetherDefault);
            let $radio2 = $(optionSplit);
            let $radio3 = $(optionExisting);
            let $radio4 = $(optionNotify);
            $radio1.prop('disabled', true).trigger('change');
            $radio2.prop('disabled', true).trigger('change');
            $radio3.prop('disabled', true).trigger('change');
            $radio4.prop('disabled', false).trigger('change');
        }

        function blockDefaultRadio() {
            let $radio1 = $(optionTogetherDefault);
            let $radio2 = $(optionSplit);
            let $radio3 = $(optionExisting);
            let $radio4 = $(optionNotify);
            $radio4.prop('disabled', true).trigger('change');
            $radio1.prop('disabled', false).trigger('change');
            $radio2.prop('disabled', false).trigger('change');
            $radio3.prop('disabled', false).trigger('change');
        }

        function checkById(id) {
            let $radio = $(id);
            $radio.prop('checked', true);
            $radio.attr('checked', true).trigger('change');
            $radio.click().trigger('click');
        }


        window.setInterval(function () {
            displayShippingOptionsByBackorder();
        }, 500);

    }
});


